<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-html="config.value"></div>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};

const htmlComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins]
};

export { htmlComponent };
export default htmlComponent;
</script>
